import React, { useState } from 'react';
import styled from 'styled-components';
import { FiFilter } from "react-icons/fi";

const FilterWrapper = styled.div`
  position: relative; 
  display: inline-flex;
`;

// Filter Modal Styles
const FilterModal = styled.div`
  position: absolute;
  top: 100%;
  left:0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 300px;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease-in;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const FilterHeader = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 15px 0;
`;

const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`;

const CategoryItem = styled.button`
  padding: 12px 15px;
  border: 1px solid ${props => props.selected ? '#e63946' : '#e0e0e0'};
  border-radius: 6px;
  background-color: ${props => props.selected ? '#fff0f0' : 'white'};
  color: ${props => props.selected ? '#e63946' : '#666'};
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  
  &:hover {
    background-color: ${props => props.selected ? '#ffe6e6' : '#f9f9f9'};
    border-color: ${props => props.selected ? '#e63946' : '#ccc'};
  }
  
  &::after {
    content: "${props => props.selected ? '✓' : ''}";
    float: right;
    color: #e63946;
  }
`;

const ApplyButton = styled.button`
  width: 100%;
  background-color: #e63946;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #c1121f;
  }
`;

// Array of categories for filter menu
const categories = [
  { id: 'all', name: 'All', count: 0 },
  { id: 'mental-health', name: 'Mental Health' },
  { id: 'career', name: 'Career' },
  { id: 'relationship', name: 'Relationship' },
  { id: 'stress-management', name: 'Stress Management' },
  { id: 'life-coaching', name: 'Life Coaching' }
];

// Filter Button (update your existing FiltersButton)

const FiltersButton = styled.button`
  background-color: #ed1e24;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s;
  display: flex;

  &:hover {
    background-color: #c1121f;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

// Main Filter Component
const CategoryFilterMenu = ({ onApplyFilters }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isOpen, setIsOpen] = useState(false);

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const handleApplyFilters = () => {
    console.log("handle clicked")
    let cat = categories.findIndex(x => x.id === selectedCategory)
    onApplyFilters(categories[cat].name);
    setIsOpen(false);
  };

  const toggleFilterMenu = () => {
    console.log("toggle filter", isOpen)
    setIsOpen(!isOpen);
  };

  return (
    <FilterWrapper>
      <FiltersButton onClick={toggleFilterMenu}>
        <FiFilter /> Filters
      </FiltersButton>
      
      {isOpen && (
        <FilterModal>
          <FilterHeader>Filter by Category</FilterHeader>
          
          <CategoryList>
            {categories.map(category => (
              <CategoryItem
                key={category.id}
                selected={selectedCategory === category.id}
                onClick={() => handleCategorySelect(category.id)}
              >
                {category.name}
                {category.count > 0 && (
                  <span style={{ float: 'right', fontSize: '12px', color: '#999' }}>
                    {category.count}
                  </span>
                )}
              </CategoryItem>
            ))}
          </CategoryList>
          
          <ApplyButton onClick={handleApplyFilters}>
            Apply Filters
          </ApplyButton>
        </FilterModal>
      )}
    </FilterWrapper>
  );
};

export default CategoryFilterMenu;